// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/Fonts/DariandPashto/Bahij_Helvetica_Neue-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/Fonts/DariandPashto/Bahij_Helvetica_Neue-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/Fonts/DariandPashto/Bahij_Helvetica_Neue-Roman.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/Fonts/English/satoshi/Satoshi-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/Fonts/English/satoshi/Satoshi-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/Fonts/English/satoshi/Satoshi-Light.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-behavior: smooth;
}

video {
  border-radius: 0.4rem;
}

.react-player__preview {
  border-radius: 0.5rem;
}

.slick-slide {
  padding: 0 5px; 
} 

.arrow {
  font-size: 20px;
  border-radius: 50%;
  display: flex;
  position: absolute;
  top: 50%;
  z-index: 100;
  cursor: pointer;
  color: white;
  background-color: #38b2ac;
}

.arrow-right {
  right: -10px;
}

.arrow-left {
  left: -10px;
}

@font-face {
  font-family: 'BahijHelveticaNeue';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: bold;
}

@font-face {
  font-family: 'BahijHelveticaNeue';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: 300;
}

@font-face {
  font-family: 'BahijHelveticaNeue';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: normal;
}

@font-face {
  font-family: 'Satoshi';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
  font-weight: normal;
}

@font-face {
  font-family: 'Satoshi';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
  font-weight: bold;
}

@font-face {
  font-family: 'Satoshi';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('opentype');
  font-weight: 300;
}

/* Default styles */
body {
  font-family: 'Satoshi', sans-serif;
}

/* RTL specific styles */
[dir="rtl"] {
  font-family: 'BahijHelveticaNeue', sans-serif;
}

[dir="rtl"], 
[dir="rtl"] * {
  font-family: 'BahijHelveticaNeue', sans-serif !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,+DAAyF;EACzF,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,+DAA0F;EAC1F,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,+DAA0F;EAC1F,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,+DAAiF;EACjF,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,+DAA8E;EAC9E,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,+DAA+E;EAC/E,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,6CAA6C;AAC/C;;AAEA;;EAEE,wDAAwD;AAC1D","sourcesContent":["html {\n  scroll-behavior: smooth;\n}\n\nvideo {\n  border-radius: 0.4rem;\n}\n\n.react-player__preview {\n  border-radius: 0.5rem;\n}\n\n.slick-slide {\n  padding: 0 5px; \n} \n\n.arrow {\n  font-size: 20px;\n  border-radius: 50%;\n  display: flex;\n  position: absolute;\n  top: 50%;\n  z-index: 100;\n  cursor: pointer;\n  color: white;\n  background-color: #38b2ac;\n}\n\n.arrow-right {\n  right: -10px;\n}\n\n.arrow-left {\n  left: -10px;\n}\n\n@font-face {\n  font-family: 'BahijHelveticaNeue';\n  src: url('./assets/Fonts/DariandPashto/Bahij_Helvetica_Neue-Bold.ttf') format('truetype');\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: 'BahijHelveticaNeue';\n  src: url('./assets/Fonts/DariandPashto/Bahij_Helvetica_Neue-Light.ttf') format('truetype');\n  font-weight: 300;\n}\n\n@font-face {\n  font-family: 'BahijHelveticaNeue';\n  src: url('./assets/Fonts/DariandPashto/Bahij_Helvetica_Neue-Roman.ttf') format('truetype');\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: 'Satoshi';\n  src: url('./assets/Fonts/English/satoshi/Satoshi-Regular.otf') format('opentype');\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: 'Satoshi';\n  src: url('./assets/Fonts/English/satoshi/Satoshi-Bold.otf') format('opentype');\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: 'Satoshi';\n  src: url('./assets/Fonts/English/satoshi/Satoshi-Light.otf') format('opentype');\n  font-weight: 300;\n}\n\n/* Default styles */\nbody {\n  font-family: 'Satoshi', sans-serif;\n}\n\n/* RTL specific styles */\n[dir=\"rtl\"] {\n  font-family: 'BahijHelveticaNeue', sans-serif;\n}\n\n[dir=\"rtl\"], \n[dir=\"rtl\"] * {\n  font-family: 'BahijHelveticaNeue', sans-serif !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
